import script from "./node-agents-page.vue?vue&type=script&setup=true&lang=js"
export * from "./node-agents-page.vue?vue&type=script&setup=true&lang=js"

import "./node-agents-page.vue?vue&type=style&index=0&id=c2479f0c&lang=scss"

const __exports__ = script;

export default __exports__